import { StripeMobilePayView } from './stripe-mobile-pay-view';

export class StripeApplePayView extends StripeMobilePayView {

    constructor() {
        super();
    }

    getPaymentRequestButtonElement() {
        return `<div id='stripe_payment_request_button'></div>`;
    }

}
